// Dependencies
import React, { Component, PropTypes } from 'react';
// Stores
// Components
import { TextField, Checkbox } from 'material-ui';
import SignInForm from './signin-form';
import Error from './signin-error';
import { Link } from 'react-router';

// Util
// Put state hydration logic on success here - shouldn't have to do all this state stuff in other components;
import env from '../../utils/env';

class SignIn extends Component {

  constructor(props) {
    super(props);
    this.state = {
      emailErrorText: '',
      passwordErrorText: '',
    };
  }

  componentWillUnmount() {
    this.props.clearInfoBoxMessage();
  }

  onSubmit = (event) => {
    if (!this.refs.email.getValue() || !this.refs.password.getValue()) {
      if (!this.refs.email.getValue()) {
        this.setState({ emailErrorText: 'This is a required field' });
      }
      if (!this.refs.password.getValue()) {
        this.setState({ passwordErrorText: 'This is a required field' });
      }
    } else {
      event.preventDefault();
      this.props.onSubmit({
        sending: true,
        signinError: '',
        email: this.refs.email.getValue(),
        password: this.refs.password.getValue(),
      });
    }
  };

  handleEnter = (event) => {
    const { which, keyCode } = event;
    const code = which || keyCode;
    if (code === 13) {
      this.onSubmit(event);
    }
  };

  render() {
    return (
      <div className="user_login">
        <div className="signin_form">
          <SignInForm
            onSubmit={this.onSubmit}
            sending={this.props.sending}
          >
            <div>
              <Error {...this.props} />
              <TextField
                data-cy="singin-email"
                style={{ width: '100%' }}
                floatingLabelText="Email"
                hintText="Required"
                errorText={this.state.emailErrorText}
                onChange={() => {
                  if (this.state.emailErrorText) this.setState({ emailErrorText: '' });
                }}
                onKeyDown={this.handleEnter}
                defaultValue={this.props.email}
                ref="email"
                className="singin-email"
              />
              <TextField
                data-cy="singin-password"
                style={{ width: '100%' }}
                floatingLabelText="Password"
                hintText="Required"
                errorText={this.state.passwordErrorText}
                onChange={() => {
                  if (this.state.passwordErrorText) this.setState({ passwordErrorText: '' });
                }}
                onKeyDown={this.handleEnter}
                type="password"
                defaultValue={this.props.password}
                ref="password"
                className="singin-password"
              />
                <div style={{ overflow: 'auto', margin: '15px 0 15px -4px' }}>
                  <Checkbox
                    style={{ width: '50%', float: 'left', fontSize: '12px' }}
                    label={<span style={{ marginLeft: '-10px' }}>Remember me</span>}
                    onCheck={this.props.onCheckboxChanged}
                    checked={ this.props.rememberMe }
                  />
                  <div style={{ float: 'right', display: 'inline-block' }}>
                    <Link to="/signin/forgot-password" style={{ fontSize: '12px' }}>Forgot password?</Link>
                  </div>
                </div>
              </div>
          </SignInForm>
          <div style={{ borderTop: '1px solid #d0d0d0', paddingTop: '10px' }}>
            <span style={{ fontSize: '12px', color: 'black' }}>{"Don't have an account? "}</span>
            <a href="/signup" style={{ fontSize: '12px', display: 'block' }} id="SignUpLink">Sign up</a>
          </div>
          <Link style={{ fontSize: '12px', display: 'block' }} to={"/signin/resend-confirmation"}>Did not receive email confirmation?</Link>
        </div>
      </div>
    );
  }
}

SignIn.propTypes = {
  clearInfoBoxMessage: PropTypes.func,
  onSubmit: PropTypes.func,
  onCheckboxChanged: PropTypes.func,
  email: PropTypes.string,
  password: PropTypes.string,
  sending: PropTypes.bool,
  rememberMe: PropTypes.bool,
};

export default SignIn;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/signin/signin.jsx